var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.resolvedTag,_vm._b({tag:"component",staticClass:"card-list-item__control def-card-list-item",on:{"click":_vm.handleClick,"keydown":_vm.handleKeydown,"keyup":_vm.handleKeyup}},'component',_vm.controlAttrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }